export { FastshiftMigrationsManagementPage } from './src';
